<template>
  <div @click="$emit('click', $event)">
    <svg width="85" height="99" viewBox="0 0 85 99" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_pin)">
        <path d="M19.3455 68.9112H19.3232L42.6482 90.0124L65.9843 68.9H65.962C74.128 62.0342 78.831 51.898 78.831 41.213C78.8533 21.1758 62.6777 4.91305 42.6928 4.89065C22.708 4.86825 6.48769 21.0862 6.46535 41.1234C6.45418 51.842 11.1683 62.0118 19.3343 68.9224L19.3455 68.9112ZM42.6928 8.55312C60.6781 8.55312 75.2451 23.1806 75.2451 41.2018C75.2451 59.2454 60.6558 73.8617 42.6593 73.8617C24.6741 73.8617 10.0959 59.223 10.1071 41.1906C10.1071 23.1582 24.7076 8.54192 42.6928 8.55312Z" fill="white"/>
      </g>
      <g filter="url(#filter1_d_pin)">
        <ellipse cx="42.6481" cy="41.4516" rx="32.7199" ry="32.8056" :fill="corStatus"/>
        <path d="M42.6479 9.146C60.4413 9.146 74.8677 23.6085 74.8677 41.4517C74.8676 59.2948 60.4413 73.7573 42.6479 73.7573C24.8547 73.7572 10.4283 59.2947 10.4282 41.4517C10.4282 23.6086 24.8547 9.1461 42.6479 9.146Z" :stroke="corStatus"/>
      </g>
      <g filter="url(#filter2_d_pin)">
        <text x="42.5" y="30" fill="white" font-size="24" font-family="Roboto" font-weight="400" text-anchor="middle" dominant-baseline="middle">PA</text>
      </g>
      <g filter="url(#filter3_d_pin)">
        <text x="42.5" y="55" fill="white" font-size="32" font-family="Roboto" font-weight="600" text-anchor="middle" dominant-baseline="middle">{{ numeroFormatado }}</text>
      </g>
      <defs>
        <filter id="filter0_d_pin" x="0.465332" y="0.890625" width="84.3657" height="97.1218" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="3"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_pin"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_pin" result="shape"/>
        </filter>
        <filter id="filter1_d_pin" x="7.92822" y="7.646" width="69.4399" height="69.6113" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="1"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_pin"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_pin" result="shape"/>
        </filter>
        <filter id="filter2_d_pin" x="28.0391" y="14.9653" width="32.8945" height="23.0625" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="1" dy="1"/>
          <feGaussianBlur stdDeviation="1.5"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_pin"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_pin" result="shape"/>
        </filter>
        <filter id="filter3_d_pin" x="23.9294" y="39.1121" width="39.7656" height="29.3906" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="1" dy="1"/>
          <feGaussianBlur stdDeviation="1.5"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_pin"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_pin" result="shape"/>
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'PinPostoAvancado',
  props: {
    status: {
      type: String,
      default: 'normal',
      validator: (value) => ['normal', 'atencao', 'critico'].includes(value)
    },
    numero: {
      type: [String, Number],
      required: true,
      validator: (value) => {
        const num = parseInt(value)
        return num >= 1 && num <= 14
      }
    }
  }
})
class PinPostoAvancado extends Vue {
  get corStatus () {
    const cores = {
      critico: '#D41320',
      atencao: '#EBB111',
      normal: '#26A69A'
    }
    return cores[this.status] || cores.normal
  }

  get numeroFormatado () {
    return String(this.numero).padStart(2, '0')
  }
}

export default PinPostoAvancado
</script>

<style scoped>
</style>
